import { Scene, Choice } from "../models";
import { scenes } from "../scenes";

export class HospitalExterior extends Scene {
  image = require("@/images/Vincent_Hospital.png");
  title = "The Hospital";
  get options(): Choice[] {
    return [
      new Choice("Enter Hospital", async () => await this.navigate(scenes.EmergencyRoom())),
      new Choice("Go Left", async () => await this.navigate(scenes.BurgerJoint())),
      new Choice("Go Right", async () =>
        await this.navigate(scenes.DarethsHouseExterior())
      ),
    ];
  }
}

export default new HospitalExterior();
